import { cn } from "@cloai/uikit";
import { CSSProperties } from "react";

export const STYLES = {
  portal: {
    variants: {
      medium: {
        "--spacing-popup-widht": "calc(var(--spacing) * 125)",
      } as CSSProperties,
      wide: {
        "--spacing-popup-widht": "calc(var(--spacing) * 200)",
      } as CSSProperties,
    },
  },
  grid: {
    variants: {
      default: cn(
        "grid grid-cols-2 gap-2",
        "@lg:grid-cols-3",
        "@2xl:grid-cols-4 @2xl:gap-4",
      ),
      big: cn(
        "grid grid-cols-1 gap-2",
        "@lg:grid-cols-2",
        "@2xl:grid-cols-3 @2xl:gap-4",
      ),
    },
    animate: "",
  },
  dropzone: {
    base: cn(
      "group/item @container relative aspect-[1/2] size-full cursor-pointer overflow-hidden duration-300 select-none",
      "flex flex-col items-center justify-center gap-5 rounded-xl",
      "border-2 border-dashed border-primary bg-card p-5",
      "sm:aspect-[5/4]",
      "hover:bg-[oklch(from_var(--color-card)_calc(l_+_0.1)_c_h)]",
      "active:scale-98 active:bg-[oklch(from_var(--color-card)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    states: {
      draging: cn(
        "border-solid bg-[oklch(from_var(--color-card)_calc(l_+_0.1)_c_h)]",
      ),
      loading: cn("pointer-events-none opacity-80"),
    },
    text: cn(
      "text-center text-container-5.5 !leading-[140%] font-medium text-balance text-card-foreground/60",
    ),
  },
};
